(function () {
var $e65898d84a6b6dbe$var$archiveListingAjax = {
    offset: 0,
    postsPerPage: 2,
    submitButton: null,
    container: null,
    loader: null,
    termId: null,
    taxonomy: null,
    authorId: null,
    isLoading: false,
    init: function() {
        var _this = this;
        var _this_submitButton;
        // Use localized posts_per_page or count actual post elements
        this.postsPerPage = ajax.posts_per_page || document.querySelectorAll('.archive-listing__posts > .article').length || 9;
        this.container = document.querySelector('.archive-listing__posts');
        this.loader = document.querySelector('.loader-container');
        this.submitButton = document.querySelector('.archive-listing__load-more');
        // Initialize offset to the current number of posts shown
        this.offset = document.querySelectorAll('.archive-listing__posts > .article').length;
        // Get term and taxonomy or author from localized script
        this.termId = ajax.term_id || null;
        this.taxonomy = ajax.taxonomy || null;
        this.authorId = ajax.author_id || null;
        (_this_submitButton = this.submitButton) === null || _this_submitButton === void 0 ? void 0 : _this_submitButton.addEventListener('click', function() {
            return _this.submit();
        });
    },
    submit: function() {
        var _this = this;
        // Prevent multiple concurrent requests
        if (this.isLoading) return;
        this.isLoading = true;
        this.submitButton.disabled = true;
        var data = new FormData();
        data.append('action', ajax.action_name);
        data.append('offset', this.offset);
        data.append('posts_per_page', this.postsPerPage);
        if (this.authorId) data.append('author_id', this.authorId);
        else {
            data.append('term_id', this.termId);
            data.append('taxonomy', this.taxonomy);
        }
        data.append('nonce', ajax.nonce);
        this.loader.classList.add('active');
        fetch(ajax.ajax_url, {
            method: 'POST',
            body: data
        }).then(function(res) {
            return res.json();
        }).then(function(data) {
            var response = data.data;
            var html = response.html, hasMore = response.hasMore;
            _this.container.insertAdjacentHTML('beforeend', html);
            // Update offset to reflect new post count
            _this.offset = document.querySelectorAll('.archive-listing__posts > .article').length;
            if (!hasMore) _this.submitButton.classList.add('archive-listing__load-more--hidden');
        }).catch(function(err) {
            console.error(err);
        }).finally(function() {
            _this.loader.classList.remove('active');
            _this.isLoading = false;
            _this.submitButton.disabled = false;
        });
    }
};
document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('.archive-listing')) $e65898d84a6b6dbe$var$archiveListingAjax.init();
});

})();
//# sourceMappingURL=ajax.js.map
